// src/pages/ContactUs.jsx
import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/navbar';
import Footer from '../components/Footer/Footer';
import ContactForm from '../components/ContactForm/ContactForm';
import './ContactUs.css';
import { Container, Row, Col } from 'react-bootstrap';

const ContactUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="contact-us-page ">
            <Navbar />

            <section className="about-hero-section">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="about-hero-content">
                                {/* Main Title: About (Regular) Us (Bold) */}
                                <h1 className="about-hero-title">
                                    <span>Contact Us</span>
                                </h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <div className="container py-5 my-5">
                <div className="row">

                    {/* LEFT SIDE: Info */}
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <div className="contact-info-box">
                            <h2 className="fw-bold mb-3">Always Here to Help you</h2>
                            <p className="text-muted mb-5">
                                Reach out to us for automotive component enquiries, RFQs, or technical discussions. We are committed to providing precision solutions.
                            </p>

                            {/* Location */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-geo-alt-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Location</div>
                                    <div className="contact-text">
                                        NO : 99, SURVEY NO.561 / 1C-2,<br />
                                        PAPPARAMBAKKAM VILLAGE<br />
                                        THIRUVALLUR (TALUK & DISTRICT )– 602 025,<br />
                                        TAMIL NADU<br />
                                        INDIA
                                    </div>
                                </div>
                            </div>

                            {/* Contact */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-telephone-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Contact</div>
                                    <div className="contact-text">
                                        +91 98403 14831
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="d-flex mb-4">
                                <div className="info-icon-circle me-3">
                                    <i className="bi bi-envelope-fill"></i>
                                </div>
                                <div>
                                    <div className="contact-label">Email</div>
                                    <div className="contact-text">
                                        shanmugaperumal@dynamic-stamping.com
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    {/* RIGHT SIDE: Form */}
                    <div className="col-lg-7">
                        <ContactForm />
                    </div>

                </div>
            </div>

            {/* Map Section */}
            <div className="map-wrapper mt-4 mb-3">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15546.667794833256!2d79.914!3d13.06!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5289c000000001%3A0x0!2zMTPCsDAzJzM2LjAiTiA3OcKwNTQnNTAuNCJF!5e0!3m2!1sen!2sin!4v1650000000000!5m2!1sen!2sin"
                    className="map-frame"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Dynamic Stamping Location"
                ></iframe>
            </div>

            <Footer />
        </div>
    );
};

export default ContactUs;
